<template>
    <div v-if="loading" class="loadingCard">
        <md-progress-spinner :md-diameter="100" :md-stroke="10" class="md-accent" 
            md-mode="indeterminate" />
    </div>
</template>

<script>
export default {
  name: 'Spiner',
  props: {
      loading: {
          type: Boolean,
          default: false
      }
  }
}
</script>

<style lang="scss" scoped>
    .loadingCard {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
        overflow: hidden;
    }
</style>